// extracted by mini-css-extract-plugin
export default {"Slot":"TeamSlot_Slot__RrVLb","Available":"TeamSlot_Available__eoH7E","Unavailable":"TeamSlot_Unavailable__fUbau"};